import { LiaTemperatureLowSolid } from "react-icons/lia";
import CardLayout from "../common/CardLayout";
import TitleCard from "../common/TitleCard";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import Table from "../common/table";
import { useEffect, useState } from "react";
import getCurrentUnidadeId from "../../funcs/getCurrentUnidadeId";
import apiAmbientes from "../../services/apis/apiAmbientes";
import { format } from "date-fns";
import { orderBy } from "../../funcs";

export default function Ambientes() {

    const unidadeId = getCurrentUnidadeId();
    const [leituras, setLeituras] = useState([]);

    useEffect(() => {
        (async () => {
            const res = await apiAmbientes.getByUnidadeId(unidadeId);
            const ambientes = res.data;
            const leiturasAmbientes = ambientes.map(({leiturasAmbientes}) => (leiturasAmbientes[0]));
                        
            orderBy(leiturasAmbientes, "ambienteId");
            setLeituras(leiturasAmbientes);
        })();
    },[unidadeId]);

    return <CardLayout>
    <Accordion
        type="single"
        defaultValue="item-1"
        collapsible="true"
    >
        <AccordionItem value="item-1">
            <div className="font-semibold">
                <AccordionTrigger>
                    <TitleCard>
                        Ambientes
                        <p className="text-lg lg:text-4xl px-2">
                            <LiaTemperatureLowSolid />
                        </p>
                    </TitleCard>
                </AccordionTrigger>
            </div>
            <AccordionContent>
                <div className="w-full">
                        <Table.Root>
                            <Table.Head>
                                {/* <Table.Header>
                                    <p className="font-bold">
                                        . . .
                                    </p>
                                </Table.Header> */}
                                <Table.Header>
                                    Ambiente id
                                </Table.Header>
                                <Table.Header>
                                    Data Hora
                                </Table.Header>
                                <Table.Header>
                                    Temperatura
                                </Table.Header>
                            </Table.Head>
                            <Table.Body>
                                {leituras?.map(
                                    (
                                        leitura
                                    ) => (
                                        <Table.Row
                                            key={
                                                leitura.id
                                            }
                                        >
                                            <Table.Data>
                                                {
                                                    leitura.ambienteId
                                                }
                                            </Table.Data>
                                            <Table.Data>
                                                {
                                                    format(leitura.dataHora, "dd/MM/yyyy HH:mm:ss") === "01/01/0001 00:00:00" ? "Sem leitura" : format(leitura.dataHora, "dd/MM/yyyy HH:mm:ss")
                                                }
                                            </Table.Data>
                                            <Table.Data>
                                                {
                                                    leitura.temperaturaAtual
                                                }
                                            </Table.Data>
                                        </Table.Row>
                                    )
                                )}
                            </Table.Body>
                        </Table.Root>
                </div>
            </AccordionContent>
        </AccordionItem>
    </Accordion>
</CardLayout>
}